var rUpper = /([A-Z])/g;
export default function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/hyphenate.js
// module id = 1199
// module chunks = 0